import { Type } from '@angular/core';
import posthog from 'posthog-js';

export type FeatureFlagComponent = Type<unknown>;
export type FeatureFlagComponentLoader = () => Promise<FeatureFlagComponent>;
export type FeatureFlagVariant = string | boolean;

export interface FeatureFlagVariantTarget {
  variant: FeatureFlagVariant;
  loader: FeatureFlagComponentLoader;
  isEligible?: () => boolean;
}

export const loadComponentByFeatureFlag = (
  featureFlagKey: string,
  variants: FeatureFlagVariantTarget[],
  fallbackComponentLoader: FeatureFlagComponentLoader,
) => {
  return async (): Promise<FeatureFlagComponent> => {
    try {
      const featureFlagVariant = posthog.getFeatureFlag(featureFlagKey);
      const matchedVariant = variants.find(
        ({ variant, isEligible }) =>
          variant === featureFlagVariant && (isEligible?.() ?? true),
      );

      if (matchedVariant) {
        return await matchedVariant.loader();
      }
    } catch {
      return await fallbackComponentLoader();
    }

    return await fallbackComponentLoader();
  };
};
